import {LOGIN_USER, VERIFY_TOKEN, REQUEST_PASSWORD_RESET, FORGOT_PASSWORD, ACTIVE_USER, CHANGE_PASSWORD} from "@/gql";
import {apolloClient} from '@/apollo'
import router from "@/router";
import Swal from "sweetalert2";

export const state = {
    loading: false,
    errors: [],
    activeUser: localStorage.getItem('activeUser') || {},
    token: localStorage.getItem('token') || null,
    userPermissions: localStorage.getItem('userPermissions') || []
}
export const getters = {
    isLoggedIn: state => !!state.token,
    activeUser: state => state.activeUser,
    authLoading: state => state.loading,
    authErrors: state => state.errors,
    userPermissions: state => state.userPermissions.length > 0 ? JSON.parse(state.userPermissions) : []
}
export const actions = {

    async loginUser({commit, dispatch}, userData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {tokenAuth}} = await apolloClient.mutate({
                mutation: LOGIN_USER,
                variables: userData
            })
            dispatch('setAuthUserPayload', tokenAuth)
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async setAuthUserPayload({commit}, payload){
        await commit('LOGIN_USER', payload)
        await commit('SET_TOKEN', payload)

        localStorage.setItem('token', payload.token)
        localStorage.setItem('activeUser', JSON.stringify(payload.user))
        localStorage.setItem('userPermissions', JSON.stringify(payload.permissions))

        window.location.reload()
    },

    async verifyToken(){
        const token = localStorage.getItem('token') || ''
        try{
            let {data: {verifyToken}} = await apolloClient.mutate({
                mutation: VERIFY_TOKEN,
                variables: {token: token}
            })
            return verifyToken
        }catch (e) {
            // console.log('error',e.graphQLErrors[0])
            // console.log('auth page',isAuthPage)
            // if (!isAuthPage){
            //     if (e.graphQLErrors[0].message){
            //         dispatch('tokenNotVerified', e.graphQLErrors[0].message)
            //     }
            // }

            return e.graphQLErrors[0].message
        }

    },

    async tokenNotVerified({dispatch}, errorMessage){
        if(errorMessage === 'Signature has expired'){
            console.log('logout user session expired')
            dispatch('logoutUser')
            await logoutMessage()
            await router.push({name: 'login', query: {redirectFrom: this.$route.fullPath}})
        }else if(errorMessage === 'Error decoding signature'){
            console.log('logout user token error')
            dispatch('logoutUser')
            await router.push({name: 'login', query: {redirectFrom: this.$route.fullPath}})
        }
    },

    async logoutUser({commit}){
        commit('LOGOUT_USER')
        localStorage.removeItem('token')
        localStorage.removeItem('activeUser')
        localStorage.removeItem('userPermissions')

        await router.push('/login')
    },

    async requestPasswordChange({commit}, email){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {requestReset}} = await apolloClient.mutate({
                mutation: REQUEST_PASSWORD_RESET,
                variables: email
            })
            await Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: requestReset.message,
                showConfirmButton: false,
                footer: '<a href="/login">Login</a>'
            })

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async forgotPassword({commit}, passwordData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {changePassword}} = await apolloClient.mutate({
                mutation: FORGOT_PASSWORD,
                variables: passwordData
            })
            await Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: changePassword.message,
                showConfirmButton: false,
            })
            await router.push('/login')

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async changePassword({commit}, passwordData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')

        try{
            let {data: {forgotPassword}} = await apolloClient.mutate({
                mutation: CHANGE_PASSWORD,
                variables: passwordData
            })
            await Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: forgotPassword.message,
                showConfirmButton: false,
            })
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async fetchActiveUser({commit}){
        commit('LOADING_TRUE')
        try{
            let {data: {me}} = await apolloClient.query({
                query: ACTIVE_USER
            })
            return me
        }catch (e) {
            console.log(e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
}
export const mutations = {
    LOGIN_USER(state, payload){
        state.activeUser = payload.user
    },
    SET_TOKEN(state, payload){
        state.token = payload.token
    },
    LOGOUT_USER(state){
        state.token = null
        state.activeUser = {}
        state.userPermissions = []
    },
    LOADING_TRUE(state){
        state.loading = true
    },
    LOADING_FALSE(state){
        state.loading = false
    },
    SET_ERRORS(state, payload){
        state.errors = payload
    },
    REMOVE_ERRORS(state){
        state.errors = []
    }
}

async function logoutMessage(){
    await Swal.fire({
        icon: 'error',
        title: 'Authentication',
        text: 'Session has expired',
        showConfirmButton: false,
        timer: 1500
    })
}


